/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsDisconnectedDeploymentStateEnum } from './vcdsDisconnectedDeploymentStateEnum';
import { CommerceModeEnum } from './commerceModeEnum';


export interface PatchDisconnectedVLRSpecOperator { 
    commerce_mode?: CommerceModeEnum;
    component_name?: string;
    /**
     * Component Version
     */
    component_version?: string;
    deactivation_code?: string;
    expiry_date?: Date;
    fqdn?: string;
    orgId: string;
    quantity?: number;
    sequence_number?: number;
    state?: VcdsDisconnectedDeploymentStateEnum;
    vcenter_id?: string;
}
export namespace PatchDisconnectedVLRSpecOperator {
}


